module.exports = __webpack_public_path__ + "static/media/et-logo-full.b3123af8.png";